function removeTrailingSlash(path) {
  return path.replace(/\/$/, '');
}
function isUrl(proposal) {
  try {
    const url = new URL(proposal);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (exception) {
    return false;
  }
}
export { removeTrailingSlash, isUrl };